import { gql } from '@apollo/client';

const ADMIN_CONSOLE_FUNNEL_FRAGMENT = gql`
  fragment AdminConsoleFunnel on VOLUNTEER_FunnelType {
    funnelId
    name
    slug
    description
    image
    expiresAt
    lockPrograms
    lockActivities
    lockRoles
    showTaskList
    dateCreated
    isActive
    applicationCount
    programs {
      programId
      name
    }
    activities {
      activityId
      name
      activityLocation {
        placesAddress {
          formatted
        }
      }
    }
    activityRoles {
      activityRoleId
      name
    }
    seekVolunteerOpportunity {
      seekOpportunityId
      region
      datePublished
    }
  }
`;

export const ADMIN_CONSOLE_FUNNELS_QUERY = gql`
  query GetAdminConsoleFunnels {
    orgLogo
    vm {
      funnels {
        ...AdminConsoleFunnel
      }
    }
    wm {
      integrationApps {
        name
      }
    }
  }
  ${ADMIN_CONSOLE_FUNNEL_FRAGMENT}
`;
